import React, { Fragment } from "react";
import '../scss/style.css';
import '../scss/dialog.css';

const Loader = props => {

    const { stan } = props;

    return (
        <Fragment>
            {
                stan ? (
                    <div
                        className="dialog block"
                    >
                        <div
                            className="logo"
                        >
                        </div>
                    </div>
                ) : ""
            }
        </Fragment>
    )
}

export default Loader;